import React from "react";

import { CircularProgress } from "@mui/material";

import "../../css/documentView.css";

interface DocumentsGridProps {
  summary: string;
  loading: boolean;
}

export const SummaryView: React.FC<DocumentsGridProps> = ({ summary, loading }) => {
  return (
    <div className="flex flow-column" style={{ gap: "15px" }}>
      {loading ? (
        <div style={{ display: "flex", alignItems: "center" }}>
          <CircularProgress size={40} />
        </div>
      ) : (
        <>
          <div
            data-testid="summary-container"
            style={{
              maxHeight: "40vh",
              overflow: "auto",
            }}
          >
            {summary}
          </div>
          <span style={{ fontStyle: "italic" }}>
            This summary was generated using GenAI technologies. Please review to confirm accuracy.
          </span>
        </>
      )}
    </div>
  );
};
